// extracted by mini-css-extract-plugin
export default {"tag":"ExpirationDateCell_tag__pe3a1","far":"ExpirationDateCell_far__cDys9","soon":"ExpirationDateCell_soon__viaIR","due":"ExpirationDateCell_due__N65C-"};